import React from 'react'
import axios from 'axios'
import { List, Box, Typography, Input,TableContainer, Table, 
TableRow, TableHead, TableBody, Paper, Pagination} from '@mui/material';
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom'
import legolasApi from '../../api/legolas'
import ChannelDropDown from '../common/ChannelDropDown';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function InvoiceList() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [columnsOpen, setColumnsOpen]= React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: '_id', label: 'Invoice ID' }, 
    { id: 'invoiceNumber', label: 'Invoice No.' }, 
    { id: 'orderId', label: 'Order ID'}, 
    { id: 'orderDate', label: 'Placed On'},
    { id: 'subtotal', label: 'Subtotal'}, 
    { id: 'shippingCharges', label: 'Shipping Charges' },
    { id: 'items', label: 'Total Items' },
    { id: 'channelName', label: 'Channel' }
  ])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalCount, setTotalCount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [searchString, setSearchstring] = React.useState('')
  const navigate = useNavigate();
  const [channelData, setChannelData] = React.useState([]);
  const [channelFilterArray, setChannelFilterArray] = React.useState([]);
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];

  const allTableHeaders = [
    { id: 'incrementId', label: 'Invoice Number' }, 
    { id: 'orderId', label: 'Order ID'}, 
    { id: 'orderDate', label: 'Placed On'},
    { id: 'subtotal', label: 'Subtotal'}, 
    { id: 'shippingCharges', label: 'Shipping Charges' },
    { id: 'items', label: 'Total Items' }
  ]

  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleColumnClick = (e) =>  {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  function findChecked(headerId, headerArr) {
    let checked = false
    for (let i = 0; i< headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['id'] == headerId) {
        checked = true
        break
      }
    }
    return checked
  }

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel}
    const currentSelected = selectedHeaders
    currentSelected.push(headerObj)
    setColumnsOpen(false)
    setSelectedHeaders(currentSelected)
  }

  function resetTableHeaders() {
    setSelectedHeaders([
      { id: 'incrementId', label: 'Invoice Number' }, 
      { id: 'orderId', label: 'Order ID'}, 
      { id: 'orderDate', label: 'Placed On'},
      { id: 'subtotal', label: 'Subtotal'}, 
      { id: 'shippingCharges', label: 'Shipping Charges' }, 
      { id: 'items', label: 'Total Items' }
    ])
    setColumnsOpen(false)
  }

const buildInvoicePayload = (page = 1, searchStr = '', channelOverride = null) => {
  const offset = (page - 1) * 50;

  let channelPayload = channelOverride !== null
    ? channelOverride
    : (channelFilterArray?.length > 0 ? channelFilterArray : userChannels);

  const payload = {
    offset,
    limit: 50,
  };

  if (searchStr?.trim()) {
    payload.orderId = searchStr.trim();
  }

  if (channelPayload?.length > 0) {
    payload.channel = channelPayload;
  }

  return payload;
};

  const handleSearch = () => {
   // const searchQuery = { "orderId" : searchString }
         const payload = buildInvoicePayload(1,searchString);

    axios.post(`${legolasApi.url}/admin/invoices`, payload).then((res) => {
      // console.log('admin/creditMemos res: ', res)
      const data = res.data.data.data, count = res.data.data.count
      setListData(data)
      setTotalCount(count)
    }).catch((error) => console.log('Error in getting invoices: ', error))
  }
  const getChannel=()=>{
    axios.get(`${legolasApi.url}/admin/channel/list`)
    .then((res) => {
      console.log('order res: ', res.data.data);
      //setChannelData(res.data.data);
       const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
    })
    .catch((error) => console.log('Error in getting orders: ', error));
  }

  React.useEffect(() => {
    getChannel();
    // const fetchAll = {

    // }
    const fetchAll = buildInvoicePayload();
    axios.post(`${legolasApi.url}/admin/invoices`, fetchAll).then((data) => {
      console.log('Res: ', data)
      if (data.data.success) {
        setListData(data.data.data.data)
        setTotalCount(data.data.data.count)
      }
    })
  }, [])

  const trimId = (inputId) => {
    return inputId.substring(0, 7);
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' +  year + '  ' + formattedTime
  }

  const handleEditClick = (orderId, order) => {
    const link =  `/invoice/${orderId}`
    navigate(link, { state: { data: order, source: 'list' }})
  }
  

  const handleFilters = (field, value) => {
  console.log("Filter input:", value);
  let newChannelFilterArray = channelFilterArray;

  if (field === 'channel') {
    newChannelFilterArray = value === null ? [] : value;
    setChannelFilterArray(newChannelFilterArray);
  }

  const filterChannels = newChannelFilterArray?.length > 0 ? newChannelFilterArray : userChannels;
  const payload = buildInvoicePayload(1, searchString, filterChannels);

  axios.post(`${legolasApi.url}/admin/invoices`, payload)
    .then((res) => {
      const data = res.data.data.data, count = res.data.data.count;
      setListData(data);
      setTotalCount(count);
    })
    .catch((error) => console.log('Error in getting invoices: ', error));
};

  const handlePagination = (event, value) => {
    console.log('Pagination value: ', value)
    const paginationPayload = {
    //  "channel":  channelFilterArray == null||channelFilterArray.length === 0 ? null : channelFilterArray,
    channel: channelFilterArray?.length ? channelFilterArray : userChannels,
    }
    axios.post(`${legolasApi.url}/admin/invoices?offset=${value-1}`,paginationPayload).then((res) => {
      console.log('nani res.data', res.data.data.data)
      const data = res.data.data.data, count = res.data.data.count
      setCurrentPage(value)
      setListData(data)
      setTotalCount(count)
    })
  }
  if (listData == []) return null
  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Invoices</Typography>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              {totalCount} record(s) found
            </Typography>
          </Box>
        </Box>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              margin: '0px 30px 10px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              } 
            }}>
              <Input
                type='search' 
                sx={{ border: '1px solid #2b3f7a', borderRadius: '20px',height:'40px', marginTop:'20px',marginRight:'5%' }} 
                endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
                placeholder='Seach by Order ID'
                onChange={(e) => setSearchstring(e.target.value)}
              />
              { userChannels.length > 1 && ( <ChannelDropDown channelData={channelData} handleChannelFilter={handleFilters}/> )}
            </Box>
        </Box>
        <Box>
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                {selectedHeaders.map((header) => [
                  <StyledTableCell align='center'>{header.label}</StyledTableCell>
                ])}
                <StyledTableCell align='center'>Action</StyledTableCell>
              </TableHead>
              <TableBody>
                {listData.map((order) => {
                      return (
                        <StyledTableRow id={order._id} key={order._id}>
                          {selectedHeaders.map((header) => {
                            if(header.id === '_id'){
                              return (
                                <Tooltip title={order[header.id]}>
                                  <StyledTableCell align='center'>{trimId(order[header.id])}</StyledTableCell>
                                </Tooltip>
                              )
                            }else if (header.id === 'createdAt') {
                              return (
                                <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                              )
                            } else if (header.id == 'items') {
                              return (
                                <StyledTableCell align='center'>{order[header.id].length}</StyledTableCell>
                              )
                            }  else if (header.id === 'subtotal') {
                              return (
                                <StyledTableCell align="center" key={header.id}>
                                  {parseFloat(order[header.id]).toFixed(2)}
                                </StyledTableCell>
                              )
                            } else {
                              return (
                                <StyledTableCell align='center'>
                                  {order[header.id]}
                                </StyledTableCell>
                              )
                            }
                          })}
                          <StyledTableCell align='center'>
                            <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => handleEditClick(order.orderId, order)}/>
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Pagination count={Math.ceil(totalCount/50)} page={currentPage} onChange={handlePagination}/>
      </List>
    </React.Fragment>
  )
}

export default React.memo(InvoiceList)